module.exports = __webpack_public_path__ + "img/creative-commons.70c466d7.svg";